<template>
  <div class="record-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="expandText">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="12">
                <FormItem label="标题" prop="title">
                  <Input v-model="filterModel.title" placeholder="输入标题" />
                </FormItem>
              </i-col>
              <i-col span="12">
                <FormItem label="保证人" prop="guarantorName">
                  <Input v-model="filterModel.guarantorName" placeholder="输入保证人名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="12">
                <FormItem label="评测等级" prop="grade">
                  <Input v-model="filterModel.grade" placeholder="输入评测等级" />
                </FormItem>
              </i-col>
              <i-col span="12">
                <FormItem label="状态" prop="status" style="width: 100%">
                  <Select v-model="filterModel.status" filterable multiple>
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.appraisalStatus)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row>
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
    <Modal v-model="showDetailModal" title="详情" :z-index="900" @on-cancel="closeDetailModal">
      <table class="detail-table" v-if="currentModel&&currentModel.title">
        <tr>
          <th>标题</th>
          <td>{{ currentModel.title }}</td>
        </tr>
        <tr>
          <th>评分表达式</th>
          <td>{{ currentModel.scoreFormula }}</td>
        </tr>
        <tr>
          <th>大题数量</th>
          <td>{{ currentModel.sectionCount }} <Button type="primary" ghost @click="openSectionPicker">选择大题</Button></td>
        </tr>
        <tr>
          <th>题目数量</th>
          <td>{{ currentModel.questionCount }}</td>
        </tr>
        <tr>
          <th>创建时间</th>
          <td>{{ $moment(currentModel.createTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
        </tr>
      </table>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'paper-list',
  props: {
  },
  components: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '标题',
          key: 'title',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '企业名称',
          key: 'guarantorName',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.$common.appraisalStatusColor[params.row.status.toString()]
              }
            }, this.$common.appraisalStatus[params.row.status.toString()])
          }
        },
        {
          title: '分发时间',
          key: 'createTime',
          sortKey: 'createTime',
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.createTime ? this.$moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-')
          }
        },
        {
          title: '上交时间',
          key: 'submitTime',
          sortKey: 'submitTime',
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.submitTime ? this.$moment(params.row.submitTime).format('YYYY-MM-DD HH:mm:ss') : '-')
          }
        },
        {
          title: '审核时间',
          key: 'auditTime',
          sortKey: 'auditTime',
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.auditTime ? this.$moment(params.row.auditTime).format('YYYY-MM-DD HH:mm:ss') : '-')
          }
        },
        {
          title: '计算得分',
          key: 'calculatedScore',
          width: 90,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.calculatedScore !== null && params.row.calculatedScore !== undefined ? params.row.calculatedScore.toFixed(2) : '-')
          }
        },
        {
          title: '审核得分',
          key: 'adjustedScore',
          width: 90,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.adjustedScore !== null && params.row.adjustedScore !== undefined ? params.row.adjustedScore.toFixed(2) : '-')
          }
        },
        {
          title: '评级结果',
          key: 'grade',
          width: 90,
          resizable: true,
        },
        {
          title: '操作',
          width: 180,
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '查看试卷',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-desktop'
                  },
                  on: {
                    click: () => {
                      this.goViewPaper(params.row)
                    }
                  }
                }, null)
              ]),
              this.checkRolePermitted(['总监管人','管理员'])
                && params.row.status === 1
              ? h('Tooltip', {
                props: {
                  content: '审核试卷',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'success',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-checkbox-outline'
                  },
                  on: {
                    click: () => {
                      this.$router.push(`/guarantor-appraisal/audit/${params.row.tid}`)
                    }
                  }
                }, null),
              ]) : null,
              this.checkRolePermitted(['总监管人','管理员'])
              ? h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tId = params.row.tid
                      this.deleteItem(tId)
                    }
                  }
                }, null)
              ]) : null
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        title: null,
        status: [],
        guarantorName: null,
        grade: null,
        sortBy: 'tid',
        ascending: false
      },
      currentModel: null,
      showDetailModal: false,
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  computed: {
    expandText () {
      return (this.tableToolsPanel.indexOf('filter') > -1 ? '隐藏' : '展开') + '筛选条件'
    }
  },
  mounted () {
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    goViewPaper (record) {
      if (record && record.paperId) {
        let isGuarantor = this.checkRolePermitted(['保证人'])
        let isAdmin = this.checkRolePermitted(['总监管人','管理员'])
        if (isGuarantor) {
          if ([0, 9].indexOf(record.status) >= 0) {
            this.$router.push(`/guarantor-appraisal/self/${record.tid}`)
          } else {
            this.$router.push(`/guarantor-appraisal/record/${record.tid}`)
          }
        } else if (isAdmin) {
          if ([1].indexOf(record.status) >= 0) {
            this.$router.push(`/guarantor-appraisal/audit/${record.tid}`)
          } else if ([0].indexOf(record.status) >= 0) {
            this.$router.push(`/guarantor-appraisal/view-paper/${record.paperId}`)
          } else {
            this.$router.push(`/guarantor-appraisal/record/${record.tid}`)
          }
        } else {
          this.$Message.error('无权访问!')
        }
      } else {
        this.$Message.error('数据有误!')
      }
    },
    closeDetailModal () {
      this.currentModel = null
      this.showDetailModal = false
    },
    checkRolePermitted (roles) {
      // if (this.$store.getters.userInfo.type === 127) {
      //   return true
      // }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Appraisal.listRecord(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.data = res.data
      this.$Spin.hide()
    },
    async deleteItem (tId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该记录么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Appraisal.deleteAppraisalRecord(tId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.tid === tId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
